export default {
    currentGroupElement: null,
    currentSourceElement: null,
    currentGroupSourceFieldMap: null,
    currentDataImportElement: null,
    importComparisonResult: {
        importType: null,
        currentElement: null,
        importedElement: null,
        differences: [],
    },
    importSetupModalData: {
        importType: null,
        data: null,
    },
};
